var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataImportModule',_vm._g(_vm._b({attrs:{"import-url":"/workspace/manager/status/change/procedure/batch/dormancy","inline":""}},'DataImportModule',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }